const config = {
  MULTIPLE_SESSIONS: process.env.MULTIPLE_SESSIONS === 'true',
  STUB_PORT: process.env.STUB_PORT || '8081',
  STUB_API_PATH: '/stub-api',
  DASHBOARD_PATH: '/dashboard',
  DYSON_STUB_COOKIE_NAME: 'ui_global_dyson_session',
}

module.exports = config
